import { ReactElement, ReactNode } from 'react'
import parse, { DOMNode, Element, HTMLReactParserOptions, domToReact } from 'html-react-parser'
import { VodInfo } from '@schemas/non-auth'
import ArticleText from './ArticleText'
import ParticleChart from './Chart'
import ParticleIframe from './Iframe'
import VideoBox from './VideoBox'
import FBPost from './FBPost'
import ImageBox from './ImageBox'
import JchLink from './JchLink'
import ParticleLink from './Link'
import ParticleImg from './Img'

const hasDomId = (id: string, dom?: DOMNode['parent']) => {
	return dom === null || (dom instanceof Element && dom.attribs.id === id)
}

const articlePartial = (content: string, vodInfoList?: Array<VodInfo>, articleIdx?: string) =>
	parse(content.replaceAll('http://', '//'), {
		replace(domNode) {
			if (domNode instanceof Element) {
				if (domNode.name === 'iframe') {
					const {
						attribs: { width, height },
					} = domNode
					if (!Number.isNaN(Number(width)) && !Number.isNaN(Number(height))) {
						return (
							<ParticleIframe ratio={`${width}/${height}`}>
								{domToReact([domNode as DOMNode])}
							</ParticleIframe>
						)
					}
				}
				if (domNode.name === 'img') {
					return <ParticleImg dom={domNode} />
				}
				if (
					(domNode.parent as Element)?.attribs?.class !== 'ab_chart_dynamic' &&
					domNode.name !== 'span'
				) {
					// eslint-disable-next-line no-param-reassign
					delete domNode.attribs.style
				}
				/** chart */
				if (
					domNode.name === 'script' &&
					(domNode.parent as Element).attribs.class === 'ab_chart_dynamic'
				) {
					return (
						<ParticleChart>
							{domToReact(domNode.children as Array<DOMNode>)}
						</ParticleChart>
					)
				}
				if (domNode.attribs.class?.includes('ab_photo')) {
					return <ImageBox dom={domNode} />
				}
				if (domNode.attribs.class?.includes('jtbc_vod')) {
					const videoIdx = domNode.attribs.id.replace('div_', '')
					const vodInfo = vodInfoList?.find((vod) => vod.videoIdx === videoIdx) ?? {
						videoIdx,
						videoType: {
							code: 'NORMAL',
							name: '일반',
						},
						playTime: '',
						vodThumbnailImgUrl: '',
					}
					return (
						vodInfo && (
							<VideoBox
								key={`vod-${videoIdx}`}
								videoInfo={vodInfo}
								articleIdx={articleIdx}
							/>
						)
					)
				}
				if (domNode.attribs.class?.includes('fb-post')) {
					return <FBPost attr={domNode.attribs} />
				}
				if (domNode.attribs.class === 'jch_link') {
					return <JchLink dom={domNode} />
				}
				if (['b', 'strong', 'i', 'u', 'font', 'span'].includes(domNode.name)) {
					return (
						<ArticleText component={domNode.name}>
							{domToReact([domNode as DOMNode])}
						</ArticleText>
					)
				}
				if (['p'].includes(domNode.name)) {
					return (
						<ArticleText component={domNode.name}>
							{domToReact(domNode.children as Array<DOMNode>)}
						</ArticleText>
					)
				}
				if (domNode.name === 'a') {
					if (domNode.attribs?.href && domNode.attribs.href !== '') {
						return <ParticleLink dom={domNode} />
					}
				}
				if (domNode.attribs.class?.includes('script_box_title')) {
					return domToReact([domNode as DOMNode])
				}
				if (domNode.attribs.class?.includes('script_box_content')) {
					return domToReact([domNode as DOMNode])
				}
				if (domNode.name === 'h2') {
					return domToReact([domNode as DOMNode])
				}
				return domNode
			}
			if (domNode.type === 'text') {
				return <ArticleText>{domNode.data}</ArticleText>
			}
			return domNode
		},
	} as HTMLReactParserOptions) as ReactElement

export default articlePartial
